import { render } from "./BasicListGroup.vue?vue&type=template&id=7715994a&scoped=true"
import script from "./BasicListGroup.vue?vue&type=script&lang=js"
export * from "./BasicListGroup.vue?vue&type=script&lang=js"

import "./BasicListGroup.vue?vue&type=style&index=0&id=7715994a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7715994a"]])

export default __exports__